import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardHeader from '@mui/material/CardHeader';
import apiGateway from '../../lib/apiGateway';
import Main from '../../ripple/Containers/Main';

class GameOption extends Component {
  static propTypes = {
    gameId: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    relay: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
  };

  constructor() {
    super();
    this.state = {
      option: null,
    };
  }
  UNSAFE_componentWillMount() {
    const { gameId, slug } = this.props;
    apiGateway.getGameOptionBySlug(gameId, slug)
      .then((data) => {
        this.setState({ option: data });
      })
      .catch(() => {});
  }

  render() {
    const { option } = this.state;
    const meta = [
      {
        property: 'og:type',
        content: 'article',
      },
      {
        property: 'og:tag',
        content: 'sponsored',
      },
      {
        property: 'og:title',
        content: option?.asset?.name,
      },
      {
        property: 'og:description',
        content: option?.asset?.description,
      },
      option?.asset
        ? {
          property: 'og:image',
          content: option?.asset.hlsPlaylistUrl,
        }
        : {},
      {
        property: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        property: 'twitter:title',
        content: option?.asset?.name,
      },
      {
        property: 'twitter:description',
        content: option?.asset?.description,
      },
      option?.asset
        ? {
          property: 'twitter:image',
          content: option?.asset.hlsPlaylistUrl,
        }
        : {},
    ];
    const { viewer } = this.props;
    return (
      <Main viewer={viewer} meta={meta}>
        <Card>
          <CardHeader title={option?.name} subheader={option?.asset?.description} />
          <CardMedia>
            <img src={option?.asset?.hlsPlaylistUrl} alt={option?.optionName || ''} />
          </CardMedia>
          <CardContent>{option?.asset?.description}</CardContent>
        </Card>
      </Main>
    );
  }
}

GameOption.propTypes = {
  gameId: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
  relay: PropTypes.object.isRequired,
  viewer: PropTypes.object.isRequired,
};

export default GameOption;
